import m from "../../prime-src/prepare";
import Move from "./Move";
import Reset from "./Reset";
import Exit from "./Exit";

export default function FSGo() {
  return (
    <div id="fuzzy-search-container" className="fs-container" style={{display:'none'}}>
      <div className="fs-name">Go: Fuzzy search</div>
      <Move></Move>
      <textarea id="fuzzy-search" className="fs-input"></textarea>
      <div id="fuzzy-search-list" className="fs-list"></div>
      <Reset></Reset>
      <Exit onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyG' } as any)}></Exit>
    </div>
  );
}
